import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import TrustSignals from './components/TrustSignals';
import LeadCaptureForm from './components/LeadCaptureForm';
import PhotoGallery from './components/PhotoGallery';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24 md:h-40">
            <div className="flex items-center gap-4 md:gap-6">
              <img 
                src="https://static.readdy.ai/image/7952c1edd780462186458d18cb4f26e0/c6f1d5166ee85a0e65936426d673604b.jpeg" 
                alt="Las Cruces Injury - Personal Injury Attorney" 
                title="Las Cruces Injury - Personal Injury Attorney"
                className="h-20 md:h-40 w-auto"
              />
              <a 
                href="https://www.facebook.com/people/Las-Cruces-Injury/61586799041875/?mibextid=wwXIfr&rdid=QbvgJZHeH9nTpDfs&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1F8xxLvDJV%2F%3Fmibextid%3DwwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full transition-colors cursor-pointer ${isScrolled ? 'bg-[#1877F2] hover:bg-[#0C63D4]' : 'bg-white/20 hover:bg-white/30'}`}
                aria-label="Visit our Facebook page"
              >
                <i className={`ri-facebook-fill text-xl md:text-2xl ${isScrolled ? 'text-white' : 'text-white'}`}></i>
              </a>
              <a 
                href="https://www.instagram.com/lascrucesinjury1?igsh=MXZuc3l6MWlkcXV3Zw%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full transition-colors cursor-pointer ${isScrolled ? 'bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F56040] hover:opacity-90' : 'bg-white/20 hover:bg-white/30'}`}
                aria-label="Visit our Instagram page"
              >
                <i className={`ri-instagram-fill text-xl md:text-2xl ${isScrolled ? 'text-white' : 'text-white'}`}></i>
              </a>
            </div>
            
            {/* Mobile menu button */}
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 rounded-md cursor-pointer"
            >
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
            </button>

            {/* Desktop menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#about" className={`text-lg font-semibold underline decoration-2 underline-offset-4 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#D2691E]' : 'text-white hover:text-[#F4A460]'}`}>About Us</a>
              <a href="#services" className={`text-lg font-semibold underline decoration-2 underline-offset-4 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#D2691E]' : 'text-white hover:text-[#F4A460]'}`}>Services</a>
              <a href="#gallery" className={`text-lg font-semibold underline decoration-2 underline-offset-4 transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#D2691E]' : 'text-white hover:text-[#F4A460]'}`}>Gallery</a>
              <div className="flex items-center gap-2">
                <span className={`text-sm font-medium ${isScrolled ? 'text-gray-600' : 'text-white/90'}`}>
                  <i className="ri-translate-2 w-4 h-4 inline-flex items-center justify-center mr-1"></i>
                  Se Habla Español
                </span>
              </div>
              <a href="#contact" className="bg-[#D2691E] text-white px-6 py-2.5 rounded-full text-base font-semibold hover:bg-[#A0522D] transition-colors cursor-pointer whitespace-nowrap">
                Free Consultation • Consulta Gratis
              </a>
            </div>
          </div>

          {/* Mobile menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-white shadow-lg rounded-lg mt-2 py-4">
              <a 
                href="https://www.facebook.com/people/Las-Cruces-Injury/61586799041875/?mibextid=wwXIfr&rdid=QbvgJZHeH9nTpDfs&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1F8xxLvDJV%2F%3Fmibextid%3DwwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-4 py-3 text-base font-semibold text-gray-700 hover:bg-gray-50 cursor-pointer"
              >
                <i className="ri-facebook-fill text-[#1877F2] text-xl"></i>
                Follow us on Facebook
              </a>
              <a 
                href="https://www.instagram.com/lascrucesinjury1?igsh=MXZuc3l6MWlkcXV3Zw%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-4 py-3 text-base font-semibold text-gray-700 hover:bg-gray-50 cursor-pointer"
              >
                <i className="ri-instagram-fill text-[#E1306C] text-xl"></i>
                Follow us on Instagram
              </a>
              <a 
                href="#about" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-3 text-base font-semibold text-gray-700 hover:bg-gray-50 cursor-pointer"
              >
                About Us
              </a>
              <a 
                href="#services" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-3 text-base font-semibold text-gray-700 hover:bg-gray-50 cursor-pointer"
              >
                Services
              </a>
              <a 
                href="#gallery" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-3 text-base font-semibold text-gray-700 hover:bg-gray-50 cursor-pointer"
              >
                Gallery
              </a>
              <div className="px-4 py-2 text-sm font-medium text-gray-600 border-t border-gray-100 mt-2 pt-4">
                <i className="ri-translate-2 w-4 h-4 inline-flex items-center justify-center mr-1"></i>
                Se Habla Español
              </div>
              <a 
                href="#contact" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="block mx-4 mt-2 text-center bg-[#D2691E] text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-[#A0522D] cursor-pointer"
              >
                Free Consultation<br/>
                <span className="text-sm">Consulta Gratis</span>
              </a>
            </div>
          )}
        </div>
      </nav>

      <Hero />
      <AboutUs />
      <Services />
      <TrustSignals />
      <LeadCaptureForm />
      <PhotoGallery />
      <FAQ />
      <Footer />
    </div>
  );
}
